import React from 'react';

/**
 * @param {['disabled' | 'success' | 'warning' | 'error' | 'info' | 'important']} status
 * @param String text
 * @
 *
 * Text with colored status label
 *
 */
export const Status = _ref => {
  let {
    status = 'info',
    text
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "status-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: `status-dot status-dot-${status}`
  }), text);
};